import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TenantParent } from '@tenant-parent/models/tenant-parent';
import { TenantParentHttpService } from '@tenant-parent/services/tenant-parent-http.service';

@Injectable({
  providedIn: 'root'
})
export class TenantParentService {
  constructor(private readonly httpService : TenantParentHttpService ) {
    
  }

  load(refNumber: number) : Observable<TenantParent> {
    return this.httpService.getParentDetails(refNumber);
  }

}
